import React from "react";
import {
    Box,
    Tooltip,
    IconButton,
} from "@mui/material";

import {
    Delete,
    ContentCopy,
    CheckCircle,
    Link as LinkIcon,
    HourglassBottom,
    RestartAlt,
} from "@mui/icons-material";

const PaymentActions = React.memo(function PaymentActions({
    row,
    rowIndex,
    onDelete,
    onApprove,
    onGenerateLink,
    onCopyLink,
    onView,
    isAdmin,
    isSuperUser,
    onMarkUnderProcess,
    onRevertToWaiting,
}) {

    if (row.status === "P") {
        return (
            <Box display="flex" gap={0.35}>
                <Tooltip title="Delete">
                    <IconButton
                        size="small"
                        color="error"
                        onClick={() => onDelete(row._id, row.payableAmount)}
                    >
                        <Delete fontSize="10px" />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Copy Link">
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => onCopyLink(row)}
                    >
                        <ContentCopy fontSize="10px" />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    }

    if (row.status === "A" && isAdmin) {
        return (
            <Box display="flex" gap={0.35}>
                <Tooltip title="Delete">
                    <IconButton
                        size="small"
                        color="error"
                        onClick={() => onDelete(row._id, row.payableAmount)}
                    >
                        <Delete fontSize="10px" />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Approve">
                    <IconButton
                        size="small"
                        color="success"
                        onClick={() => onApprove(row._id)}
                    >
                        <CheckCircle fontSize="10px" />
                    </IconButton>
                </Tooltip>
            </Box>
        );
    }

    // Super-admin-only: no one else sees or can trigger either of these.
    // The backend (POST /payment/mark-under-process,
    // /payment/revert-to-waiting) re-checks isSuperUser itself, so this
    // visibility rule is a convenience, not the actual boundary. Same
    // status ("W") either way — which action shows depends on whether this
    // link is already flagged via the dedicated `queuedForProcessing` field
    // (not `remarks`, which the ordinary Finance approve flow already sets
    // to the literal "Under Process" for every Waiting link regardless of
    // this feature — matching on that would have made "Mark as Under
    // Process" show up as already-toggled for virtually every real Waiting
    // row, and "Revert to Waiting" would have wiped Finance's own state).
    if (row.status === "W" && isSuperUser) {
        const isUnderProcess = Boolean(row.queuedForProcessing);
        return (
            <Tooltip title={isUnderProcess ? "Revert to Waiting" : "Mark as Under Process"}>
                <IconButton
                    size="small"
                    color={isUnderProcess ? "info" : "warning"}
                    onClick={() =>
                        isUnderProcess
                            ? onRevertToWaiting(row._id)
                            : onMarkUnderProcess(row._id)
                    }
                >
                    {isUnderProcess ? <RestartAlt fontSize="10px" /> : <HourglassBottom fontSize="10px" />}
                </IconButton>
            </Tooltip>
        );
    }

    if (
        row.status === "F" &&
        row.isClub === true &&
        row.isNewLink === false
    ) {
        return (
            <Tooltip title="Generate New Link">
                <IconButton
                    size="small"
                    color="primary"
                    onClick={() => onGenerateLink(row)}
                >
                    <LinkIcon fontSize="10px" />
                </IconButton>
            </Tooltip>
        );
    }

    return "";
});

export default PaymentActions;